import {
  useQuery,
  useQueryClient,
  type QueryKey,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { Action, Subject } from '@erp/authz';

import { useCan } from '@/hooks/useCan';

/**
 * What a background-run card (Feedback, Mass Renewal) reads first: whether
 * the viewer may start a run, and the organization's latest run for the
 * supplier, polled by `options`. `setLatestRun` puts a just-started run in
 * its place so polling takes over from it.
 */
export function useLatestRun<TRun, TKey extends QueryKey>(
  options: UseQueryOptions<
    { run: TRun | null },
    Error,
    { run: TRun | null },
    TKey
  >,
) {
  const queryClient = useQueryClient();
  const [allowed] = useCan(Action.Create, Subject.Pricing);
  const runQuery = useQuery(options);
  return {
    allowed,
    runQuery,
    run: runQuery.data?.run ?? null,
    setLatestRun: (run: TRun) =>
      queryClient.setQueryData<{ run: TRun | null }>(options.queryKey, {
        run,
      }),
  };
}
